import { useState } from "react";
import { Menu, X, Waves } from "lucide-react";
import { scrollToId, CONTACT } from "@/lib/scroll";

const LINKS = [
  { label: "About", href: "#about", testid: "nav-link-about" },
  { label: "The Name", href: "#the-name", testid: "nav-link-the-name" },
  { label: "Approach", href: "#approach", testid: "nav-link-approach" },
  { label: "Focus Areas", href: "#focus", testid: "nav-link-focus" },
  { label: "Services", href: "#services", testid: "nav-link-services" },
  { label: "Slow Water", href: "#reflections", testid: "nav-link-reflections" },
  { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const go = (href) => {
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-pawc-sand/80 border-b border-pawc-teal/10"
    >
      <div className="max-w-6xl mx-auto px-6 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.6 })}
          className="flex items-center gap-3 text-left"
        >
          <img
            src="/images/logo-mark.png"
            alt="Yielding logo, water curling around a smooth stone"
            className="w-10 h-10 object-contain"
          />
          <span>
            <span className="block font-serif text-lg leading-tight text-pawc-deep">
              {CONTACT.brand}
            </span>
            <span className="block text-[10px] tracking-[0.3em] uppercase text-pawc-slate">
              {CONTACT.brandSub}
            </span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-8" aria-label="Primary">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={l.testid}
              onClick={() => go(l.href)}
              className="text-sm text-pawc-slate hover:text-pawc-teal transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-book-btn"
            onClick={() => go("#contact")}
            className="rounded-full bg-pawc-terra hover:bg-pawc-terraDark text-white text-sm px-6 py-2.5 transition-colors duration-300"
          >
            Book a Session
          </button>
        </nav>

        <button
          data-testid="nav-menu-toggle"
          className="lg:hidden text-pawc-deep p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Close menu" : "Open menu"}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <nav
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t border-pawc-teal/10 bg-pawc-sand/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5"
          aria-label="Mobile"
        >
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`${l.testid}-mobile`}
              onClick={() => go(l.href)}
              className="text-left font-serif text-2xl text-pawc-deep"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-book-btn-mobile"
            onClick={() => go("#contact")}
            className="mt-2 rounded-full bg-pawc-terra text-white px-6 py-3 text-sm w-fit"
          >
            Book a Session
          </button>
        </nav>
      )}
    </header>
  );
};
